import { Link,AppBar, Box, Toolbar, Typography, useMediaQuery, useTheme } from "@mui/material";
import {  Outlet } from "react-router-dom";
import LogoTecmilenio from "../../Media/LogoTecmilenio.svg"
import CuadrosIzq from "../../Media/Cuadros izq.svg"
const Layout = () => {

    const theme = useTheme();
    const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('sm'));


    return (
        <>
            <AppBar position="static" elevation={0}
                sx={{
                    backgroundColor: "transparent",
                    boxShadow: "none",
                    px: 2,
                    marginTop: 3,
                    marginBottom: 3
                }}>
                <Toolbar
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                    <Box component="img" src={LogoTecmilenio} alt="Logo Tecmilenio"
                        sx={{ height: "44px", width: "208px" }} />
                    <Box component="img" src={CuadrosIzq} alt="Logo Tecmilenio"
                        sx={{ height: "76px", width: "114px" }} />
                </Toolbar>
            </AppBar>


            <Outlet />

            <AppBar position={isMobileOrTablet ? "static" : "fixed"}
                sx={{ top: "auto", bottom: 0, backgroundColor: theme.palette.primary.main, px: 2, mt: 2 }}>
                <Toolbar
                    sx={{
                        display: "flex",
                        flexDirection: isMobileOrTablet ? "column" : "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: isMobileOrTablet ? 1 : 0
                    }}>
                    <Typography variant="body2" sx={{ pl: isMobileOrTablet ? 0 : 2 }}>
                        © Copyright {new Date().getFullYear()}. Todos los derechos reservados
                    </Typography>
                    <Typography variant="body2" sx={{ pr: isMobileOrTablet ? 0 : 2 }}>
                        <Link underline="none" target="_blank" rel="noopener noreferrer" color="inherit"  href={"https://tecmilenio.mx/es/terminos-y-condiciones"}>Términos y condiciones</Link> | <Link underline="none" target="_blank" rel="noopener noreferrer" color="inherit" href={"https://tecmilenio.mx/es/politicas-de-privacidad"}>Privacidad</Link>
                    </Typography>
                </Toolbar>
            </AppBar>
        </>
    )
}
export default Layout;